import { Pipe, PipeTransform } from '@angular/core';
import { Printer, PrinterSetup } from 'src/app/views/models/printer.model';

@Pipe({
  name: 'printerFinder'
})
export class PrinterFinderPipe implements PipeTransform {

  transform(id: number, setups: PrinterSetup[], printers: Printer[]): number {
    const EXIST = setups.find(x => x.table_record_id === id);
    if (EXIST) {
      return printers.findIndex(x => x.id === EXIST.printer_id);
    }
    return null;
  }

}
